// extracted by mini-css-extract-plugin
export default {"root":"EditFees_root__ttOqq","body":"EditFees_body__BYYDO","typeLabel":"EditFees_typeLabel__xjRUe","type":"EditFees_type__CwU9d","button":"EditFees_button__V0iNS"};